<template>
    <div :class="['ac-checkbox', className, size]">
        <label
            checkbox=""
            :input-checked="checkValue"
            :class="[isRound ? 'ensure-round-box' : 'ensure-box', disabled ? 'ensure-disabled' : '']"
        >
            <input type="checkbox"
                class="ensure-input"
                :disabled="disabled"
                @click.stop="">
            <span
                class="check-icon"
                :class="{
                    'icon-checked': checkValue,
                    'icon-indeterminate': indeterminate && !checkValue
                }"
                checkicon=""
                @click.stop="changeInputChecked"
            ><icon-right /></span>
        </label>
        <p class="ensure-clue">
            <slot />
            <span v-show="required" class="ensure-flag">*</span>
        </p>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import IconRight from '@/components/Svg/IconRight.vue';

export default Vue.extend({
    components: {
        IconRight
    },
    model: {
        prop: 'modelValue',
        event: 'change'
    },
    props: {
        isRound: {
            type: Boolean,
            default: true
        },
        className: String,
        modelValue: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        indeterminate: {
            type: Boolean,
            default: false
        },
        isCanSelect: {
            type: Boolean,
            default: true
        },
        size: {

            type: String,
            validator( type: string ): boolean {

                let types = ['small', 'middle'];
                return types.includes( type );

            },
            default() {

                return 'middle';

            }

        }
    },
    computed: {
        checkValue: {
            get(): boolean {

                return this.modelValue;

            },
            set( value: boolean ) {

                this.$emit( 'change', value );

            }
        }
    },
    methods: {
        changeInputChecked(): void {

            if ( this.disabled ) return;
            if ( !this.isCanSelect ) {

                this.$emit( 'click' );

            }

            this.checkValue = !this.checkValue;

        }
    }
});
</script>
<style lang='less' scoped>
.ac-checkbox {
    display: flex;
    height: @reo-checkbox-check-icon-width;
    &.small{
        height: 20px;
        display: inline-flex;
        align-items: center;
    }
}
.ensure-box {
    flex-grow: 0;
    display: flex;
    cursor: pointer;
    font-size: 18px;
    color: #555555;
    line-height: 1.6;
     @media screen and (max-width: 1199px) {
        font-size: .18rem;
     }
    .ensure-input {
        display: none;
    }
    .check-icon {
        margin: 0;
    }
    .ensure-clue {
        color: #555;
        line-height: 1.6;
        font-weight: 400;
        font-size: 18px;

    }
    .ensure-flag {
        color: #BF352E;
        font-size: 14px;
        font-weight: 500;
    }
}
.ensure-round-box {
    flex-grow: 0;
    display: flex;
    cursor: pointer;
    font-size: 22px;
    color: #555555;
    line-height: 1.6;
    @media screen and (max-width: 1199px) {
        font-size: .18rem;
    }
    .ensure-input {
        display: none;
    }
    .check-icon {
        margin: 0;
        background-color: @white;
    }
    .ensure-clue {
        color: #555;
        line-height: 1.6;
        font-weight: 400;
        font-size: 18px;

    }
    .ensure-flag {
        color: #BF352E;
        font-size: 14px;
        font-weight: 500;
    }
}

.small .ensure-round-box{
    font-size: 16px;
    line-height: 1;
}

.icon-checked() {
    border: none !important;
    background-color: @blue_6;
    color: #fff;
    transition: transform 3s ease-in 2s;
    transform-origin: center;
}

.ensure-box[checkbox] .check-icon {
    border-radius: 4px;
    width: @reo-checkbox-check-icon-width;
    height: @reo-checkbox-check-icon-height;
    box-sizing: border-box;
    border: @reo-checkbox-check-border;
    background-color: @bg_02;
    display: inline-block;
    position: relative;
    overflow: hidden;
    line-height: 0;
    color: transparent;
    &.icon-checked {
        .icon-checked();
    }
    &.icon-indeterminate {
        .icon-checked();
        /deep/ svg{
            visibility: hidden;
        }
        &::after{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 60%;
            height: 3px;
            background-color: #fff;
            border-radius: 1px;
            transform: translate(-50%, -50%);
        }
    }
    /deep/ svg{
        width: @reo-checkbox-check-icon-width;
        height: @reo-checkbox-check-icon-height;
    }
}

.ensure-round-box[checkbox] .check-icon {
    border-radius: 50%;
    width: @reo-checkbox-check-icon-width;
    height: @reo-checkbox-check-icon-height;
    box-sizing: border-box;
    border: @reo-checkbox-check-border;
    display: inline-block;
    position: relative;
    overflow: hidden;
    line-height: 0;
    color: transparent;
    &.icon-checked {
        .icon-checked();
    }
    &.icon-indeterminate {
        .icon-checked();
        /deep/ svg{
            visibility: hidden;
        }
        &::after{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 60%;
            height: 3px;
            background-color: #fff;
            border-radius: 1px;
            transform: translate(-50%, -50%);
        }
    }
    /deep/ svg{
        width: @reo-checkbox-check-icon-width;
        height: @reo-checkbox-check-icon-height;
        visibility: hidden;
    }
}

.small .ensure-round-box[checkbox] .check-icon {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
    /deep/ svg{
        width: 16px;
        height: 16px;
    }
}

.ensure-clue {
    font-size: 16px;
}

.ensure-disabled{
    cursor: no-drop !important;
}

.ensure-disabled[checkbox] .check-icon {
    width: @reo-checkbox-check-icon-width;
    height: @reo-checkbox-check-icon-height;
    box-sizing: border-box;
    border: 2px solid @line_dark;
    background-color: @fill_disable_dark;
    display: inline-block;
    position: relative;
    /deep/ svg{
        width: @reo-checkbox-check-icon-width;
        height: @reo-checkbox-check-icon-height;
    }
}

</style>
